import { useNavigate } from "react-router-dom";
import {
  getUserData,
  setSelectedSearchOrderType,
} from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "../../SchedularModal";
import { useEffect, useRef, useState } from "react";
import { formatDate, localeDateEndDate, localeDateStartDate, maskMobileNumber } from "../../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import StoreMenu from "../../StoreMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonLink from "../../../ButtonLink";
import { whatsAppNotification } from "../../../services/StoreNotification/StoreNotification";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import usePackageLogStore from "../../StoreContext/usePackageLogStore";
import { CustomerOrderPackageLog } from "../../../services/PackageLog/PackageLog";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";

const { innerWidth: width, innerHeight: height } = window;

const PackageLogStore = () => {
  const navigate = useNavigate();

  const { storeData, userProfileRole, brandProfileData } = getUserData();

  const storeId = storeData.id;
  const storeName = storeData.storeName;
  let brandId = brandProfileData.id;
  const {
    sortingData,
    setSortingData,
    validData,
    setValidData,
    schedularDate,
    setSchedularDate,
    customerALLOrdersData,
    setCustomerALLOrdersData,
    page,
    setPage,
    searchTerm,
    setSearchTerm,
    useEffectCall,
    setUseEffectCall,
  } = usePackageLogStore()

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  // const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  // const [page, setPage] = useState(0);
  // const [useEffectCall, setUseEffectCall] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchTermClean, setSearchTermClean] = useState(false);
  // const [searchTerm, setSearchTerm] = useState("");

  const [searchFilterValue, setSearchFilterValue] = useState("INVOICE");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);
  const [carryForwardFilter, setCarryForwardFilter] = useState(false);
  const [leftCarryForwardFilter, setLeftCarryForwardFilter] = useState(false);


  const initializeVariable = () => {
    setCustomerALLOrdersData([]);
  };
  
  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  // const [sortingData, setSortingData] = useState(false)

  const handleSortData = () => {
    setUseEffectCall(true);
    setPage(0);
    setSortingData(!sortingData);
  };

  const handleValidData = () => {
    setUseEffectCall(true);
    setPage(0);
    setValidData(!validData);
  };

  // const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const fetchPackageLogData = (data) => {
    setLoading(true);
    CustomerOrderPackageLog({
      ...data,
      limit: 15,
      offset: page * 15, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
        //   if (page === 0) {
        //     setCustomerALLOrdersData(Res); // Reset state with new data
        //   } else {
        //     setCustomerALLOrdersData((prevData) => [...prevData, ...Res]);
        //   }
        if (page === 0) {
            setCustomerALLOrdersData(Res); // Reset with fresh data
          } else {
            setCustomerALLOrdersData((prevData) => {
              const existingIds = new Set(prevData.map((item) => item.id));
              const newUniqueData = Res.filter((item) => !existingIds.has(item.id));
              return [...prevData, ...newUniqueData];
            });
          }
          setLoading(false);
          setLoadingSearch(false);
          setSearchTermClean(false);
          setIsEndReached(Res.length < 15);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
        setSearchTermClean(false);
      });
  };
  // for all status and one week data or by default data;
  const data = {
    storeIds: [storeId],
    brandId: brandId,
    // startDate:startDate,
    // endDate:endDate,
    sortOrder:"desc",
    sortBy: 'id',
    valid: false,
  };
  const [requestData, setRequestData] = useState(data);

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : validData ? null : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : validData ? null : localeDateEndDate(new Date(endDate));
        requestData.sortOrder = sortingData ? "asc" : "desc";
        requestData.carryForward = carryForwardFilter;
        requestData.leftCarryForward = leftCarryForwardFilter;
        requestData.valid = validData ? true : false;
      setPage(0);
      fetchPackageLogData(requestData);
    }
  }, [schedularDate, sortingData ,searchTermClean, carryForwardFilter, leftCarryForwardFilter, validData]);

  useEffect(() => {
    fetchPackageLogData(data);
  }, []);

  useEffect(() => {
    requestData.searchText = searchTerm;
    if (page > 0) fetchPackageLogData(requestData);
  }, [page]);
 
  const handleCarryForward = (data) => {
    setUseEffectCall(true);
    setPage(0);
    setCarryForwardFilter(data);
    // requestData.carryForward = data;
    // requestData.leftCarryForward = !data;
    // setPage(0);
    // fetchPackageLogData({ ...requestData, offset: 0 });
  };

  const handleLeftCarryForward = (data) => {
    setUseEffectCall(true);
    setPage(0);
    setLeftCarryForwardFilter(data);
    // requestData.carryForward = !data;
    // requestData.leftCarryForward = data;
    // setPage(0);
    // fetchPackageLogData({ ...requestData, offset: 0 });
  };

  const handleSearchFilterChange = async (selectedItem) => {
    setSearchFilterValue(selectedItem);
    handleSearchType();
    await setSelectedSearchOrderType(selectedItem);
  };

  const FilterList = [
    {
      name: "By Name",
      value: "NAME",
    },
    {
      name: "By Invoice No.",
      value: "INVOICE",
    },
    {
      name: "By Mobile No.",
      value: "MOBILE",
    },
  ];

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setUseEffectCall(true);
    setPage(0);
    setSearchTermClean(true);
    fetchPackageLogData(data);
  };

  const searchTermApiCall = (text) => {
    if (text !== '') {
      setLoadingSearch(true);
      setSearchTerm(text)
      setPage(0);
      requestData.searchBy = searchFilterValue !== "" ? searchFilterValue : "INVOICE";
      requestData.searchText = text;
      fetchPackageLogData(requestData);
    } else {
      setSearchTerm('')
      setLoadingSearch(true);
      setUseEffectCall(true);
      setPage(0);
      setSearchTermClean(true)
    }
  };

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };
 
  const itemTemplate = (data) => {
    const index = customerALLOrdersData.findIndex(
      item => item === data
    );
    const formattedCreatedDate = formatDate(data.createdDate);

    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
        <AccordionTab
          key={data.id} // Use a more unique key like data.id
          header={`${
            data?.packageDTO?.name || "N/A"}`}
        >
          <div
            className="cursor-pointer"
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.packageDTO?.name || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  App Service :
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.packageDTO?.appService}
                </p>
              </div>
            </div>

            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.packageDTO?.name || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Mobile No.:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.packageDTO?.name || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Notification:</p>
                <p className="text-lg font-bold capitalize">
                  {data?.packageDTO?.name || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };
 

  const quantityBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        <span>
          {rowData?.packageDTO?.serviceUnit === 'Qty' 
          ? rowData.packageDTO.quantity + ' Pcs'
          : rowData.packageDTO.quantity + ' ' + rowData.packageDTO?.serviceUnit
          
          }
        </span>
      </div>
    );
  };

  const quantityUsedBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        <span>
          {rowData?.packageDTO?.serviceUnit === 'Qty' 
          ? rowData.itemCount + rowData.countGram + ' Pcs'
          : rowData.itemCount + rowData.countGram + ' ' + rowData.packageDTO?.serviceUnit
          
          }
        </span>
      </div>
    );
  };

  const leftPackageQuantityBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        {rowData.carryForwardCount !== null &&
            <span>
          {rowData?.packageDTO?.serviceUnit === 'Qty' 
          ? rowData.carryForwardCount + ' Pcs'
          : rowData.carryForwardCount + ' ' + rowData.packageDTO?.serviceUnit
          
          }
        </span>}
      </div>
    );
  };

  const validBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        {!rowData.carryForward && rowData.carryForwardCount > 0 &&
            <span>
          {formatDate(rowData?.validOn)}
        </span>}
      </div>
    );
  };

  const rowClass = (rowData) => {
    return {
        'bg-carry-forward': rowData.carryForward
    };
};


  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={15}
        rowsPerPageOptions={[15, 20, 30, 50]}
        tableStyle={{ minWidth: "120rem" }}
        rowClassName={rowClass}
        scrollable
        scrollHeight={height - 160}
      >
      <Column
                header="S No."
                style={{ width: "80px" }}
                body={(rowData, options) =>
                  options.rowIndex + 1}
              ></Column>
        <Column
          field="invoiceNo"
          header="Name"
          style={{ width: "200px" }}
          body={(rowData) => rowData?.packageDTO?.name}
        ></Column>
        <Column
          field="date"
          header="Date"
          style={{ width: "130px" }}
          body={(rowData) => formatDate(rowData?.createdDate)}
        />
        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "150px" }}
          body={(rowData) => rowData?.order?.customerName}
        />
        <Column
          field="customerMobile"
          header="Mobile"
          style={{ width: "120px" }}
          body={(rowData) => maskMobileNumber(rowData?.order?.customerMobile)}
        ></Column>
        <Column
          field="invoiceNo"
          header="Bill No."
          style={{ width: "120px" }}
          body={(rowData) => rowData?.order?.invoiceNo}
        ></Column>
        <Column
          field="quantity"
          header="Quantity"
          style={{ width: "100px" }}
          body={quantityBodyTemplate}
        ></Column>
        <Column
          field="PackageAmount"
          header="Package Amount"
          body={(rowData) => rowData?.packageDTO?.amount}
        ></Column>
        <Column
          field="quantityUsed"
          header="Quantity Used"
          body={quantityUsedBodyTemplate}
        ></Column>
        <Column
          field="totalPrice"
          header="Total Price"
          body={(rowData) => rowData?.totalPrice}
        ></Column>
        <Column
          field="packageCount"
          header="Package Count"
          body={(rowData) => rowData?.packageCount}
        ></Column>
        <Column
          field="itemGarmentCount"
          header="Item Garment Count"
          body={(rowData) => rowData?.itemGarmentCount}
        ></Column>
        <Column
          field="carryForward"
          header="Used Carry Forward"
          body={(rowData) => (rowData?.carryForward ? "Yes" : "No")}
        ></Column>
        <Column
          field="carryForwardInvoiceNo"
          header="Reference Bill No."
          body={(rowData) =>
            rowData?.carryForward ? rowData?.carryForwardInvoiceNo : ""
          }
        ></Column>
        <Column
          field="PackageAmount"
          header="Left Package Quantity"
          body={leftPackageQuantityBodyTemplate}
        ></Column>
        <Column
          field="ValidOn"
          header="ValidOn"
          body={validBodyTemplate}
        ></Column>
      </DataTable>
    );
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };

  const filteredOrderInfoData = filterData(customerALLOrdersData, searchTerm);

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Map only the required fields for export
      const exportData = filteredOrderInfoData.map((item) => ({
        Name: item?.packageDTO?.name,
        Date: formatDate(item?.createdDate),
        "Customer Name": item?.order?.customerName,
        Mobile: maskMobileNumber(item?.order?.customerMobile),
        BillNo: item?.order?.invoiceNo,
        Quantity:
          item?.packageDTO?.serviceUnit === "Qty"
            ? item.packageDTO.quantity + " Pcs"
            : item.packageDTO.quantity + " " + item.packageDTO?.serviceUnit,
        "Package Amount": item?.packageDTO?.amount,
        "Quantity Used":
          item?.packageDTO?.serviceUnit === "Qty"
            ? item.itemCount + item.countGram + " Pcs"
            : item.itemCount +
              item.countGram +
              " " +
              item.packageDTO?.serviceUnit,
        "Total Price": item?.totalPrice,
        "Package Count": item?.packageCount,
        "Item Garment Count": item?.itemGarmentCount,
        "Used Carry Forward": item?.carryForward ? "Yes" : "No",
        "Reference Bill No.": item?.carryForward
          ? item?.carryForwardInvoiceNo
          : "",
        "Left Package Quantity":
          item.carryForwardCount !== null
            ? item?.packageDTO?.serviceUnit === "Qty"
              ? item.carryForwardCount + " Pcs"
              : item.carryForwardCount + " " + item.packageDTO?.serviceUnit
            : "",
        ValidOn:
          !item.carryForward &&
          item.carryForwardCount > 0 &&
          formatDate(item?.validOn),
      }));
  
      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
  
      saveAsExcelFile(excelBuffer, "My_" + storeName + "_Store_Package_Log");
    });
  };

  
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Subscription-Package")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Package Log
              </p>
            </div>
          </div>
          <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                />
              </div>
            </div>
          <div
            onClick={() => handleValidData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
          <p className="text-xl text-white font-medium mx-3">Valid </p>
            {validData ? (
              <img
                src={
                  "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                }
                style={{ width: "25" }}
              />
            ) : (
              <img
                src={
                  "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                }
                style={{ width: "25" }}
              />
            )}
          </div>
          <div className="flex justify-content-center align-items-center cursor-pointer">
            <div className="flex flex-1 justify-content-between my-1">
              <p className="text-xl text-white font-medium mx-3">LEFT PACKAGE</p>
              <Checkbox
                checked={leftCarryForwardFilter}
                size="20" // Increased size
                color={leftCarryForwardFilter ? "#00A3FF" : "#C1C9D3"}
                onClick={() => {
                    handleLeftCarryForward(!leftCarryForwardFilter);
                if(!leftCarryForwardFilter) {
                    setCarryForwardFilter(false)
                } else {
                    setCarryForwardFilter(true)
                }

                }
                }
              />
            </div>
          </div>
          <div className="flex justify-content-center align-items-center cursor-pointer mr-2">
            <div className="flex flex-1 justify-content-between my-1">
              <p className="text-xl text-white font-medium  mx-3">CARRY FORWARD</p>
              <Checkbox
                checked={carryForwardFilter}
                size="20" // Increased size
                color={carryForwardFilter ? "#00A3FF" : "#C1C9D3"}
                onClick={() => {
                    handleCarryForward(!carryForwardFilter);
                if(!carryForwardFilter) {
                    setLeftCarryForwardFilter(false)
                } else {
                    setLeftCarryForwardFilter(true)
                }

                }
                }
              />
            </div>
          </div>
          <div
            onClick={() => handleSortData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            )}
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
      <div className="my-2 mx-5 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={
                  searchFilterValue === "NAME"
                    ? "Search By Name"
                    : searchFilterValue === "MOBILE"
                    ? "Search By Mobile No."
                    : "Search By Invoice No."
                }
                value={searchTerm}
                keyboardType={
                  searchFilterValue === "NAME" ? "default" : "numeric"
                }
                onChange={(e) => searchTermApiCall(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm ? (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-4xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          ) : (
            <div
              onClick={handleSearchType}
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                  style={{ width: 27 }}
                />
              </div>
            </div>
          )}
        </div>
        {searchTypeToggle && (
          <div className="flex-1 mx-5 mb-4">
            <Dropdown
              value={searchFilterValue}
              onChange={(e) => handleSearchFilterChange(e.value)}
              options={FilterList}
              optionLabel="name"
              placeholder="Search Filter"
              className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
            />
          </div>
        )}
        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : customerALLOrdersData?.length > 0 ? (
          <div>
          <div>
          
            <div
              className="scroll-bar mb-2"
               
            >
            <div className="mx-4 report-table">
              <div className="tab-view-table">{RenderTabView()}</div>
            </div>
            </div>
          
          </div>
          <div style={{display:"none"}}>
              <DataScroller
                value={customerALLOrdersData}
                itemTemplate={itemTemplate}
                rows={customerALLOrdersData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height - 200}
                loader
                // footer={footer}
              />
            </div>
            </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Notification Found</p>
          </div>
        )}

        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 20, left: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>

        <SchedularModal
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
        />
        <StoreMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default PackageLogStore;
